import { getContentstackImagesForWidths } from '@noths/polaris-client-utils';
import dynamic from 'next/dynamic';

import { lazyLoadImages } from 'src/utils/images';
import { HeroBannerBlockProps } from '../../../components/blocks/HeroBannerBlock';
import { ContentBlockRenderer } from '../../../types/Block';
import { Transformer } from '../../../types/Transformer';
import { DepartmentHeroBannerSectionContent } from './types';

/* istanbul ignore next */
export const renderer: ContentBlockRenderer<HeroBannerBlockProps> = dynamic<HeroBannerBlockProps>(
  () => import('src/components/blocks/HeroBannerBlock').then((mod) => mod.HeroBannerBlock),
);

export const transformer: Transformer<DepartmentHeroBannerSectionContent, HeroBannerBlockProps> = (
  { _metadata, background_color, text_color_mode, image, heading, sub_heading, tracking_title },
  { pageConfig, positionMetadata },
) => ({
  uid: _metadata.uid,
  props: {
    headingLine1: heading,
    headingIsPageTitle: positionMetadata.position === 0 && pageConfig.pageType !== 'homepage',
    backgroundColor: background_color,
    textColorMode: text_color_mode,
    images: getContentstackImagesForWidths(image.image_source.url, [360, 500, 700, 900, 1132], {
      aspectRatio: '16:9',
    }),
    imageWidth: 360,
    imageHeight: 216,
    imageAlt: image.alt_text,
    subHeading: sub_heading,
    lazyImages: lazyLoadImages(positionMetadata.position),
    trackingTitle: tracking_title,
  },
});
